import React from 'react'
import axios from 'axios';


class DownloadClient extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            newest_cg_client_url:'',//最新版本url
        };
    }

    componentWillMount () {
        //get 请求获取 客户端文件 URL
        axios.get('/api/download/'
        ).then(response => {
              this.setState({
                newest_cg_client_url: response.data.version_newest,
              },
                  ()=>{
                    //下载最新版客户端文件
                    window.location.href = this.state.newest_cg_client_url;

                    //下载最新版客户端文件 记录在数据库中
                    axios.get('/api/cg_download/newest/')
                  });
        }).catch(error => {
        })
    }

    render() {
        return(
            <>
            </>
        )
    }
}

export default DownloadClient;

